import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../services/http-client.service';
import { ActivatedRoute } from '@angular/router';
/**
 * SingleConsultationComponent
 */
let SingleConsultationComponent = class SingleConsultationComponent {
    constructor(httpClient, route) {
        this.httpClient = httpClient;
        this.route = route;
        this.item = {};
        this.sub = this.route.params.subscribe((params) => {
            this.httpClient.get('consulting/' + +params['id']).subscribe((result) => {
                this.item = result;
            });
        });
    }
    ngOnInit() {
    }
};
SingleConsultationComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: ActivatedRoute }
];
SingleConsultationComponent = __decorate([
    Component({
        selector: 'ecd-single-consult',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./single-consultation.component.html")).default
    })
], SingleConsultationComponent);
export { SingleConsultationComponent };
